'use client';

// src/components/shared/ConditionalFooter.tsx
// Monte le SiteFooter sur tout le site, SAUF les espaces de travail
// (admin, login) où un footer public/légal n'a pas de sens.

import { useCheminSansLangue } from '@/components/i18n/LangProvider';
import { SiteFooter } from '@/components/shared/SiteFooter';

const HIDDEN_PREFIXES = ['/admin', '/login'];

export function ConditionalFooter() {
  // Sans le préfixe de langue : `/en/admin` n'existe pas, mais `/en/login` oui.
  const pathname = useCheminSansLangue();
  // Les versions imprimables (export PDF) n'ont ni pied de page ni navigation.
  if (pathname.endsWith('/imprimer')) return null;
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return null;
  }
  return <SiteFooter />;
}
